/* External */
import { createContext, useContext } from 'react';

/* Utils */
import { noOp } from '../../utils/functions';

export const InterstitialContext = createContext({
  interstitial: undefined,
  isLoading: false,
  shouldDisplay: false,
  handleInterstitialSeen: noOp,
});

export function useInterstitialInfo() {
  return useContext(InterstitialContext);
}
